module.exports = __webpack_public_path__ + "static/receiver-game-promo-tile-23e21c09feb1ff6f2385ac08225dd19b.jpg";